import { render, staticRenderFns } from "./Read.vue?vue&type=template&id=3e62dc5d&scoped=true"
import script from "./Read.vue?vue&type=script&lang=js"
export * from "./Read.vue?vue&type=script&lang=js"
import style0 from "./Read.vue?vue&type=style&index=0&id=3e62dc5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e62dc5d",
  null
  
)

export default component.exports